import { Component, Host, h, Prop, Element, State } from '@stencil/core';

@Component({
  tag: 'me-pill',
  styleUrl: 'me-pill.scss',
  shadow: false,
})
export class MePill {

  @Element() host: HTMLMePillElement;

  @Prop() offset: boolean | string = false;
  @Prop() indicator = false;

  @State() _fontSize?: string;

  private mutationObserver = new MutationObserver(this.updateFontSize.bind(this));

  connectedCallback() {
    this.mutationObserver.observe(this.host, { attributes: false, subtree: false, childList: true });
  }

  disconnectedCallback() {
    this.mutationObserver.disconnect();
  }

  render() {
    const classList = [
      'me-pill',
      this.offset ? 'me-pill--offset' : null,
      this.indicator ? 'me-pill--indicator' : null,
    ].filter(c => !!c).join(' ');

    const styles: { [key: string]: string } = {
      fontSize: this.fontSize(),
    };

    if (typeof this.offset === 'string') {
      styles.transform = this.offset;
    }

    return (
      <Host
        class={classList}
        style={styles}
      >
        <slot />
      </Host>
    );
  }

  private updateFontSize() {
    this._fontSize = this.fontSize();
  }

  private fontSize() {
    return {
      1: 'var(--me-font-size-r)',
      2: 'var(--me-font-size-xs)',
      3: 'var(--me-font-size-xxs)',
    }[this.host.textContent.trim().length] ?? '0';
  }

}
